// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project-imports
import DrawerHeaderStyled from './DrawerHeaderStyled';

import Logo from 'components/logo';
import { DRAWER_WIDTH, HEADER_HEIGHT, MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';

interface Props {
  open: boolean;
}

type DrawerPaddingValue = { xs: string; lg: string } | string;

function drawerHeaderPaddingLeft(isHorizontal: boolean, open: boolean): DrawerPaddingValue | number | undefined {
  if (isHorizontal) return { xs: '24px', lg: '0' };
  if (!open) return 0;
  return undefined;
}

function drawerHeaderPaddingY(
  isHorizontal: boolean,
  open: boolean,
  horizontal: { xs: string; lg: string }
): DrawerPaddingValue {
  if (isHorizontal) return horizontal;
  if (open) return '12px';
  return '10px';
}

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }: Readonly<Props>) {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const paddingLeft = drawerHeaderPaddingLeft(isHorizontal, open);
  const paddingTop = drawerHeaderPaddingY(isHorizontal, open, { xs: '10px', lg: '0' });
  const paddingBottom = drawerHeaderPaddingY(isHorizontal, open, { xs: '18px', lg: '0' });

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: isHorizontal ? 'unset' : HEADER_HEIGHT,
        width: isHorizontal ? { xs: '100%', lg: DRAWER_WIDTH + 50 } : '100%',
        paddingTop,
        paddingBottom,
        ...(paddingLeft !== undefined && { paddingLeft })
      }}
    >
      <Logo isIcon={!open} />
    </DrawerHeaderStyled>
  );
}
